module.exports = __webpack_public_path__ + "static/media/icon-zoom.bc6699d3.svg";